import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M 10 1 m -6 0 a 6 4 0 0 0 -2 2 l 0 2 v 26 l 1 1 a 5 5 0 0 0 2 1.5 h 20 a 6 6 0 0 0 1 -1 a 3 3 0 0 0 1 -3 V 12 l -7 -8 l -3 -3 Z m 12 3 h 0 v 9 H 24 v 17 h -7 l 0 0 v -1 a 7 5 0 0 0 -4 -4 a 0 0 0 0 0 -4 0 a 6 3 0 0 0 -4 2 a 0 0 0 0 0 0 1 a 0 -2 0 0 1 0 1 V 4 Z"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: "10.75",
  cy: "20",
  r: "3"
});

export default createSvgIcon(stroke => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 34"
}, /*#__PURE__*/React.createElement("g", {
  stroke: stroke,
  strokeWidth: "2%"
}, _ref, _ref2))), 'Facesheet');